import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const Body = styled.div(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gridGap: theme.spacing(1.5),
  marginBottom: theme.spacing(2),
  [theme.media.createObjectMediaQuery({ at: 2 })]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  [theme.media.createObjectMediaQuery({ at: 1 })]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}));

export const Header = styled(Text.withComponent('h2'))(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));
